import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useColorModeValue,
} from '@chakra-ui/react';

const GlobalModal = ({
  isOpen,
  onClose,
  title,
  children,
  footer,
  size = 'xl',
  minWidth,
  width,
  ...rest
}) => {
  const bg = useColorModeValue('white', 'navy.700');
  return (
    <Modal isOpen={isOpen} onClose={onClose} size={size} isCentered {...rest}>
      <ModalOverlay bg="rgba(0, 0, 0, 0.7)" />
      <ModalContent bg={bg} minWidth={minWidth} width={width} p={3}>
        {title && <ModalHeader>{title}</ModalHeader>}
        <ModalCloseButton />
        <ModalBody>{children}</ModalBody>
        {footer && <ModalFooter>{footer}</ModalFooter>}
      </ModalContent>
    </Modal>
  );
};

export default GlobalModal;
